import { Button } from "./Button";

interface CategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void | Promise<void>;
}

export function DeletePostModal({ isOpen, onClose, onDelete }: CategoryModalProps) {
  if (!isOpen) return null;

  const handleDelete = async () => {
    await onDelete();
    onClose();
  };

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center'>
      <div
        className='absolute inset-0 bg-black/50 backdrop-blur-sm'
        onClick={onClose}
      />
      <div className='relative bg-white rounded-lg p-4 w-96 flex gap-6 flex-col shadow-xl'>
        <div className='flex flex-col gap-1'>
          <h2 className='text-lg font-semibold capitalize'>Delete Post</h2>
          <p className='text-sm text-gray-600'>Are you sure you want to delete this post? This action cannot be undone.</p>
        </div>

        <Button
          onClick={handleDelete}
          variant='destructive'
          className='self-end'
        >
          Delete
        </Button>
      </div>
    </div>
  );
}
